import styled from 'styled-components';

import CopyLinkIcon from '~assets/images/icons/ui/copyLink.svg';

export const TitleRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const CopyLink = styled(CopyLinkIcon)`
    margin-left: 8px;
    cursor: pointer;
`;
